// Mock data for Aesthetix MD - luxury medical spa
// This data will later be served from the backend.

export const CLINIC = {
  name: "AĒSTHETIX MD",
  tagline: "Cosmetic. Medical. Wellness.",
  parent: "Qualitas Care Clinic",
  logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_aesthetix-pro-1/artifacts/l8mp08or_images.png",
  address: "12020 104 Ave NW, Suite 201, Edmonton AB T5K 0G6",
  email: "info@aesthetixmd.com",
  phone: "780-809-0870",
  hours: [
    { day: "Monday \u2013 Friday", time: "9:00 AM \u2013 5:00 PM" },
    { day: "Saturday", time: "11:00 AM \u2013 3:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  socials: {
    instagram: "https://www.instagram.com/aesthetix.md/?hl=en",
    facebook: "https://www.facebook.com/AesthetixMDYeg/",
    youtube: "https://www.youtube.com/channel/UCedTNCVuCCIOOpkDxxSeNwQ",
    linkedin: "https://ca.linkedin.com/company/aesthetix-md",
  },
};

export const IMAGES = {
  heroPortrait: "https://images.unsplash.com/photo-1672794776762-18dddc72982e",
  heroAlt: "https://images.unsplash.com/photo-1551184451-76b762941ad6",
  aboutPortrait: "https://images.unsplash.com/photo-1674932668403-33398b81c92f",
  spa1: "https://images.unsplash.com/photo-1698475378626-da1bcb22af6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcGF8ZW58MHx8fHdoaXRlfDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  spa2: "https://images.unsplash.com/photo-1598799270248-2edb41057db3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcGF8ZW58MHx8fHdoaXRlfDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  interior1: "https://images.unsplash.com/photo-1761470575018-135c213340eb",
  interior2: "https://images.unsplash.com/photo-1761971975973-cbb3e59263de",
  facial1: "https://images.unsplash.com/photo-1593986815100-7d0772982da4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxmYWNpYWwlMjB0cmVhdG1lbnR8ZW58MHx8fHdoaXRlfDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  facial2: "https://images.unsplash.com/photo-1661346376364-706a9eac60ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxmYWNpYWwlMjB0cmVhdG1lbnR8ZW58MHx8fHdoaXRlfDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  inject1: "https://images.unsplash.com/photo-1746017062285-13c77e29fc25",
  inject2: "https://images.unsplash.com/photo-1552693673-1bf958298935",
  inject3: "https://images.unsplash.com/photo-1598300188904-6287d52746ad",
  skincare1: "https://images.unsplash.com/photo-1555820585-c5ae44394b79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxza2luY2FyZXxlbnwwfHx8fDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  skincare2: "https://images.unsplash.com/photo-1581182800629-7d90925ad072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxza2luY2FyZXxlbnwwfHx8fDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  skincare3: "https://images.unsplash.com/photo-1573461160327-b450ce3d8e7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxza2luY2FyZXxlbnwwfHx8fDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  serum: "https://images.unsplash.com/photo-1585945037805-5fd82c2e60b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxza2luY2FyZXxlbnwwfHx8fDE3ODY3NzAyMDV8MA&ixlib=rb-4.1.0&q=85",
  cream: "https://images.pexels.com/photos/17891765/pexels-photo-17891765.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hairHero: "https://images.unsplash.com/photo-1564141696939-9eb6e957ccfc",
  hairConsult: "https://images.unsplash.com/photo-1512663150964-d8f43c899f76",
  hairTransplant: "https://images.unsplash.com/photo-1733685373279-a10ac3f255e7",
  hairProc: "https://images.unsplash.com/photo-1643837833100-8b2ebd7127bc",
  hairTreat: "https://images.unsplash.com/photo-1734111719430-fe4a3973f8af",
  hairGlossy: "https://images.unsplash.com/photo-1560264641-1b5191cc63e2",
  hairBlonde: "https://images.unsplash.com/photo-1554519934-e32b1629d9ee",
  hairResult: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e",
};

export const SERVICES = [
  {
    id: "botox",
    name: "Botox & Neuromodulators",
    short: "Smooth fine lines and wrinkles for a refreshed, natural look.",
    description:
      "Precisely administered neuromodulators soften dynamic wrinkles around the eyes, forehead and brows — delivering a rested, youthful expression while preserving your natural movement.",
    price: "from $9 / unit",
    duration: "30 min",
    image: IMAGES.inject2,
    category: "Injectables",
  },
  {
    id: "fillers",
    name: "Dermal Fillers",
    short: "Restore volume and sculpt your features with premium fillers.",
    description:
      "Juvederm, Restylane, Belotero, Radiesse and Sculptra — artfully placed to restore lost volume, enhance lips and cheeks, and sculpt balanced, harmonious contours.",
    price: "from $550",
    duration: "45 min",
    image: IMAGES.inject1,
    category: "Injectables",
  },
  {
    id: "prp",
    name: "Platelet Rich Plasma (PRP)",
    short: "Harness your body’s own growth factors to rejuvenate skin.",
    description:
      "Using your own concentrated platelets, PRP stimulates collagen and cellular renewal for radiant skin, improved texture and healthier hair — the ultimate natural rejuvenation.",
    price: "from $450",
    duration: "60 min",
    image: IMAGES.facial2,
    category: "Regenerative",
  },
  {
    id: "mesotherapy",
    name: "Mesotherapy",
    short: "Micro-infusions of vitamins for luminous, hydrated skin.",
    description:
      "Tailored cocktails of vitamins, antioxidants and hyaluronic acid are micro-infused into the skin to hydrate, brighten and revitalise from within.",
    price: "from $300",
    duration: "45 min",
    image: IMAGES.facial1,
    category: "Skin",
  },
  {
    id: "contouring",
    name: "Body Contouring",
    short: "Non-surgical sculpting for a refined, confident silhouette.",
    description:
      "Advanced non-invasive technology targets stubborn areas to sculpt, tighten and define — helping you achieve a smoother, more contoured silhouette with zero downtime.",
    price: "from $400",
    duration: "75 min",
    image: IMAGES.spa2,
    category: "Body",
  },
  {
    id: "weightloss",
    name: "Medical Weight Loss",
    short: "Physician-guided programs for lasting, healthy results.",
    description:
      "A personalised, physician-supervised weight management program combining medical guidance, nutrition and modern therapeutics to help you reach and maintain your goals.",
    price: "consultation",
    duration: "Program",
    image: IMAGES.skincare3,
    category: "Wellness",
  },
  {
    id: "peel",
    name: "Chemical Peels",
    short: "Reveal fresh, luminous skin with medical-grade peels.",
    description:
      "Medical-grade peels gently resurface the skin to reduce pigmentation, fine lines and blemishes — unveiling a brighter, smoother and more even complexion.",
    price: "from $150",
    duration: "45 min",
    image: IMAGES.skincare1,
    category: "Skin",
  },
  {
    id: "facials",
    name: "Medical Facials",
    short: "Bespoke facials engineered for visible, lasting results.",
    description:
      "Results-driven facials tailored to your skin’s needs — combining deep cleansing, active serums and expert technique for a healthy, radiant glow.",
    price: "from $180",
    duration: "60 min",
    image: IMAGES.facial1,
    category: "Skin",
  },
];

export const PRODUCTS = [
  {
    id: "p1",
    name: "Radiance Renewal Serum",
    price: 128,
    category: "Serums",
    image: IMAGES.serum,
    description: "A silky vitamin-C serum that brightens and firms for a luminous, even complexion.",
  },
  {
    id: "p2",
    name: "Hydra-Restore Cream",
    price: 96,
    category: "Moisturisers",
    image: IMAGES.cream,
    description: "Deeply nourishing cream with hyaluronic acid for plump, dewy, hydrated skin.",
  },
  {
    id: "p3",
    name: "Gentle Resurfacing Peel",
    price: 74,
    category: "Treatments",
    image: IMAGES.skincare2,
    description: "An at-home enzyme peel that smooths texture and refines the appearance of pores.",
  },
  {
    id: "p4",
    name: "Botanical Cleansing Oil",
    price: 58,
    category: "Cleansers",
    image: IMAGES.skincare1,
    description: "A weightless botanical oil that melts away impurities without stripping the skin.",
  },
  {
    id: "p5",
    name: "Age-Defy Eye Complex",
    price: 84,
    category: "Eye Care",
    image: IMAGES.skincare3,
    description: "Targeted peptide complex that softens fine lines and de-puffs the eye area.",
  },
  {
    id: "p6",
    name: "Luminous Glow SPF 50",
    price: 62,
    category: "Protection",
    image: IMAGES.cream,
    description: "A luxuriously light mineral sunscreen with a soft, radiant finish.",
  },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Sophia L.",
    treatment: "Dermal Fillers",
    quote:
      "The most natural results I have ever had. The team truly understands facial harmony — I look refreshed, never overdone.",
  },
  {
    id: "t2",
    name: "Amara K.",
    treatment: "Medical Facial",
    quote:
      "From the moment you walk in, it feels like a sanctuary. My skin has never looked better and I finally feel confident bare-faced.",
  },
  {
    id: "t3",
    name: "Daniela R.",
    treatment: "PRP Rejuvenation",
    quote:
      "Professional, warm and genuinely expert. Every detail is considered. Aesthetix MD is in a class of its own.",
  },
];

export const STATS = [
  { value: "10+", label: "Years of Excellence" },
  { value: "15k+", label: "Treatments Delivered" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "25+", label: "Signature Treatments" },
];

export const HAIR_SERVICES = [
  { id: "hair-loss", name: "Hair Loss Treatment", short: "Physician-led, research-proven programs to halt and reverse thinning.", description: "Hair thinning can stem from genetic and medical causes. After a consultation with a physician specialised in the field, we design a medical treatment plan tailored precisely to your needs.", price: "consultation", duration: "Program", image: IMAGES.hairConsult, category: "Restoration" },
  { id: "hair-meso", name: "Hair Mesotherapy", short: "Micro-infusions of nutrients to nourish follicles and boost density.", description: "A cocktail of vitamins, peptides and growth factors is micro-infused into the scalp to revitalise dormant follicles and encourage thicker, healthier hair.", price: "from $300", duration: "45 min", image: IMAGES.hairTreat, category: "Restoration" },
  { id: "hair-prp", name: "Hair PRP Therapy", short: "Your own growth factors to naturally stimulate regrowth.", description: "Platelet Rich Plasma harnesses concentrated growth factors from your own blood, injected into the scalp to stimulate follicles and support natural regrowth.", price: "from $450", duration: "60 min", image: IMAGES.hairProc, category: "Regenerative" },
  { id: "hair-transplant", name: "Hair Transplant", short: "Advanced surgical restoration with natural, permanent results.", description: "Our surgical hair restoration delivers permanent, natural-looking density using meticulous, research-proven techniques, planned by a physician.", price: "consultation", duration: "Procedure", image: IMAGES.hairTransplant, category: "Surgical" },
];

export const GALLERY = [
  { id: "g1", title: "Dermal Filler \u2014 Lip Enhancement", category: "Injectables", before: IMAGES.skincare1, after: IMAGES.inject1 },
  { id: "g2", title: "PRP Skin Rejuvenation", category: "Regenerative", before: IMAGES.skincare2, after: IMAGES.facial2 },
  { id: "g3", title: "Medical Facial \u2014 Glow", category: "Skin", before: IMAGES.skincare3, after: IMAGES.serum },
  { id: "g4", title: "Hair Restoration \u2014 Density", category: "Hair", before: IMAGES.hairConsult, after: IMAGES.hairGlossy },
  { id: "g5", title: "Hair PRP \u2014 Regrowth", category: "Hair", before: IMAGES.hairTreat, after: IMAGES.hairBlonde },
  { id: "g6", title: "Chemical Peel \u2014 Clarity", category: "Skin", before: IMAGES.cream, after: IMAGES.hairResult },
];

export const HAIR_MEMBERSHIPS = ["ISHRS", "AACS", "CPSA", "AMS"];
